/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import { Flex } from 'rebass';
import baseTheme from '../../../themes/baseTheme';
import {
    Grid,
    TextField,
    Container,
    Select,
    MenuItem,
    FormGroup,
    OutlinedInput,
    FormControl,
    InputLabel,
    Typography,
    InputAdornment,
    Radio,
    Checkbox,
    RadioGroup,
    FormControlLabel
} from '@material-ui/core';
import Step from './Step';
import Styled from 'styled-components';
import { Formik, Field } from 'formik';
import { Caption, Body1 } from '../../FontStyles';
import * as _ from '../../../data/constants.js';
var utils = require('../../../Utils.js');

// Page 1 of the form, collects all useful patient information regarding Patient bio and background, if a user already exists most of this information can be set
// pre filled in
const testSchema = Yup.string().min(5, 'Enter more chars');

const FieldContainer = Styled(Flex)`
width: 100%;
margin-bottom: ${props => props.theme.space[3]}px;
border: ${props => (props.border ? props.theme.border : 'none')};
border-radius: ${props => props.theme.radius}px;
.MuiFormControlLabel-root {
    width: 100%;
    padding: ${props => props.theme.space[2]}px};

}

.MuiButtonBase-root {
    margin-left: ${props => props.theme.space[2]}px};
}


`;

class PatientAccountSection extends React.Component {
    state = { errors: [], currentStepNumber: 0 };
    checkStuff = (value, fieldName) => {
        // console.log('check stuff');
        // console.log('value');
        // console.log(value);
        // console.log(_.formSchema.validateSyncAt('firstName', value));
    };

    setCurrentStepNumber = val => {
        console.log('Current Step:' + val);
        this.setState({ currentStepNumber: val });
    };

    // scroll to top on mount

    //Hook for step number, passed down for step to update.

    render() {
        const props = this.props;
        return (
            <div>
                <Step
                    prompt={`What is ${
                        this.props.values.firstName ? `${this.props.values.firstName}'s` : "the patient's"
                    } phone number?`}
                    stepNumber={0}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                >
                    <Flex width={1} flexWrap="wrap">
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="phoneNumber"
                                label="Patient Phone Number"
                                placeholder="Example: (650) 123-4567"
                                error={props.touched.phoneNumber && Boolean(props.errors.phoneNumber)}
                                helperText={props.touched.phoneNumber ? props.errors.phoneNumber : ''}
                                onChange={props.handleChange}
                                value={props.values.phoneNumber}
                            />
                        </FieldContainer>
                        <FieldContainer width={1}>
                            <FormControl>
                                <FormControlLabel
                                    name="sendLinkToPhone"
                                    control={
                                        <Checkbox
                                            color="default"
                                            checked={
                                                this.props.values.sendLinkToPhone
                                                    ? this.props.values.sendLinkToPhone
                                                    : false
                                            }
                                            onChange={this.props.handleChange}
                                        />
                                    }
                                    label={
                                        <Typography color="textSecondary">
                                            Send app download to patient's phone
                                        </Typography>
                                    }
                                />
                            </FormControl>
                        </FieldContainer>
                        <Flex width={1} textAlign="left">
                            <Body1>
                                The patient’s phone number may be used to provided direct assistance regarding their
                                Tidepool account. Standard messaging rates may apply.
                            </Body1>
                        </Flex>
                    </Flex>
                </Step>
                {/*<Step
                    prompt={`Please enter ${
                        this.props.values.firstName ? `${this.props.values.firstName}'s` : "the patient's"
                    } address?`}
                    stepNumber={4}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                >
                    <Flex width={1} flexWrap="wrap">
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                label="Patient Address"
                                name="street1Address"
                                placeholder="Example: 501 Diabetes Way"
                                error={props.touched.street1Address && Boolean(props.errors.street1Address)}
                                helperText={props.touched.street1Address ? props.errors.street1Address : ''}
                                onChange={props.handleChange}
                                value={props.values.street1Address}
                            />
                        </FieldContainer>
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="street2Address"
                                label="Patient Address Opt. Line 2"
                                error={props.touched.street2Address && Boolean(props.errors.street2Address)}
                                helperText={props.touched.street2Address ? props.errors.street2Address : ''}
                                onChange={props.handleChange}
                                value={props.values.street2Address}
                            />
                        </FieldContainer>
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="cityAddress"
                                label="Patient City"
                                placeholder="Example: Palo Alto"
                                error={props.touched.cityAddress && Boolean(props.errors.cityAddress)}
                                helperText={props.touched.cityAddress ? props.errors.cityAddress : ''}
                                onChange={props.handleChange}
                                value={props.values.cityAddress}
                            />
                        </FieldContainer>
                        <FieldContainer width={1}>
                            <FormControl variant="outlined" fullWidth required>
                                <InputLabel
                                    htmlFor="state-picker"
                                    error={props.touched.stateAddress && Boolean(props.errors.stateAddress)}
                                >
                                    Patient State
                                </InputLabel>
                                <Select
                                    name="stateAddress"
                                    input={<OutlinedInput name="stateAddress" id="state-picker" />}
                                    error={props.touched.stateAddress && Boolean(props.errors.stateAddress)}
                                    onChange={props.handleChange}
                                    value={props.values.stateAddress}
                                >
                                    {_.StatesArray.map((state, index) => {
                                        return (
                                            <MenuItem key={index} value={state}>
                                                {state}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </FieldContainer>
                        <Flex width={1} textAlign="left">
                            <Body1>
                                The patient’s phone number may be used to provided direct assistance regarding their
                                Tidepool account. Standard messaging rates may apply.
                            </Body1>
                        </Flex>
                    </Flex>
                </Step>*/}
                <Step
                    prompt={`What is ${
                        this.props.values.firstName ? `${this.props.values.firstName}'s` : "the patient's"
                    } Medical Record Number (MRN)?`}
                    stepNumber={1}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                >
                    <Flex width={1} flexWrap="wrap">
                        <FieldContainer width={1}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Medical Record Number"
                                name="mrn"
                                error={props.touched.mrn && Boolean(props.errors.mrn)}
                                helperText={props.touched.mrn ? props.errors.mrn : ''}
                                onChange={props.handleChange}
                                value={props.values.mrn}
                            />
                        </FieldContainer>
                    </Flex>
                </Step>
                <Step
                    prompt={`What is ${
                        this.props.values.firstName ? `${this.props.values.firstName}'s` : "the patient's"
                    } gender?`}
                    stepNumber={2}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                >
                    <Flex width={1} flexWrap="wrap">
                        <FieldContainer width={1}>
                            <FormControl fullWidth>
                                <RadioGroup
                                    name="gender"
                                    value={this.props.values.gender ? this.props.values.gender : ''}
                                    onChange={this.props.handleChange}
                                    row
                                >
                                    <Flex width={1} flexWrap="wrap">
                                        <FieldContainer border width={1}>
                                            <FormControlLabel
                                                value="female"
                                                control={<Radio color="default" />}
                                                label={<Typography color="textSecondary">Female</Typography>}
                                            />
                                        </FieldContainer>
                                        <FieldContainer border width={1}>
                                            <FormControlLabel
                                                value="male"
                                                control={<Radio color="default" />}
                                                label={<Typography color="textSecondary">Male</Typography>}
                                            />
                                        </FieldContainer>
                                        <FieldContainer border width={1}>
                                            <FormControlLabel
                                                value="notProvided"
                                                control={<Radio color="default" />}
                                                label={
                                                    <Typography color="textSecondary">Prefer not to specify</Typography>
                                                }
                                            />
                                        </FieldContainer>
                                    </Flex>
                                </RadioGroup>
                            </FormControl>
                        </FieldContainer>
                    </Flex>
                </Step>
                {/*
                <Step
                    finalStep
                    prompt={`Please enter ${
                        this.props.values.firstName ? `${this.props.values.firstName}'s` : "the patient's"
                    } address?`}
                    stepNumber={7}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                >
                    <Flex width={1} flexWrap="wrap">
                        <FieldContainer flexWrap="none" width={1}>
                            <Flex width={0.33} pr={3}>
                                <FormControl variant="outlined" fullWidth required>
                                    <Select
                                        name="weightUnits"
                                        input={<OutlinedInput name="weightUnits" id="state-picker" />}
                                        onChange={props.handleChange}
                                        value={props.values.weightUnits}
                                        defaultValue="kilograms"
                                    >
                                        <MenuItem key={0} value="kilograms">
                                            Kilograms
                                        </MenuItem>
                                        <MenuItem key={0} value="lbs">
                                            Lbs
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Flex>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                label="Enter Weight"
                                name="weight"
                                placeholder=""
                                onChange={props.handleChange}
                                value={props.values.weight}
                            />
                        </FieldContainer>
                    </Flex>
                </Step>*/}
                <Step
                    prompt={`Does ${
                        this.props.values.firstName ? `${this.props.values.firstName}` : 'the patient'
                    }  have the necessary prescriptions for Tidepool Loop compatible devices?`}
                    stepNumber={3}
                    currentStepNumber={this.state.currentStepNumber}
                    setCurrentStepNumber={this.setCurrentStepNumber}
                    handleSubmit={this.props.handleSubmit}
                    values={props.values}
                    setFieldValue={props.setFieldValue}
                    finalStep
                >
                    <FieldContainer width={1}>
                        <FieldContainer width={1}>
                            <FormControl>
                                <Flex width={1} mb={2}>
                                    <FormControlLabel
                                        name="hasHorizonRx"
                                        control={
                                            <Checkbox
                                                color="default"
                                                checked={
                                                    this.props.values.hasHorizonRx
                                                        ? this.props.values.hasHorizonRx
                                                        : false
                                                }
                                                onChange={this.props.handleChange}
                                            />
                                        }
                                        label={
                                            <Flex flexWrap="wrap">
                                                <Flex width={1}>
                                                    <Typography color="textSecondary">Omnipod Horizon</Typography>
                                                </Flex>
                                                <Flex width={1}>
                                                    <Caption>
                                                        Find information on how to prescribe Omnipod products here.
                                                    </Caption>
                                                </Flex>
                                            </Flex>
                                        }
                                    />
                                </Flex>
                                <FormControlLabel
                                    name="hasDexcomRx"
                                    control={
                                        <Checkbox
                                            color="default"
                                            checked={
                                                this.props.values.hasDexcomRx ? this.props.values.hasDexcomRx : false
                                            }
                                            onChange={this.props.handleChange}
                                        />
                                    }
                                    label={
                                        <Flex flexWrap="wrap">
                                            <Flex width={1}>
                                                <Typography color="textSecondary">Dexcom G6</Typography>
                                            </Flex>
                                            <Flex width={1}>
                                                <Caption>
                                                    Find information on how to prescribe Dexcom G6 sensors and
                                                    transmitters and more here.
                                                </Caption>
                                            </Flex>
                                        </Flex>
                                    }
                                />
                            </FormControl>
                        </FieldContainer>
                    </FieldContainer>
                </Step>
            </div>
        );
    }
}

export default PatientAccountSection;
